import React from 'react';
import { ActivityIcon, Building2Icon, CheckIcon, HouseIcon, SmartphoneIcon, StoreIcon, UniversityIcon } from 'lucide-react';
type Stop = {
  time: string;
  place: string;
  drink: string;
  Icon: React.ElementType;
  tone: 'default' | 'home';
};
const dayStops: Stop[] = [{
  time: '6:40 AM',
  place: 'Gym',
  drink: 'Electrolytes boost',
  Icon: ActivityIcon,
  tone: 'default'
}, {
  time: '9:15 AM',
  place: 'Workplace',
  drink: 'Cold brew coffee',
  Icon: Building2Icon,
  tone: 'default'
}, {
  time: '12:30 PM',
  place: 'Campus café',
  drink: 'Sparkling mineral',
  Icon: UniversityIcon,
  tone: 'default'
}, {
  time: '5:05 PM',
  place: 'Convenience',
  drink: 'Mango, zero sugar',
  Icon: StoreIcon,
  tone: 'default'
}, {
  time: '9:20 PM',
  place: 'JuLi Home',
  drink: 'Lemon ginger',
  Icon: HouseIcon,
  tone: 'home'
}];
const membershipFeatures = ['One identity', 'Saved preferences', 'One wallet'];
const networkEffects: Array<[string, string]> = [['Revenue follows the person', 'Not the machine — the membership travels between venues.'], ['Every endpoint is a storefront', 'Each installation can acquire and retain subscribers.'], ['Preferences compound', 'Every pour makes the next recommendation better.']];
export function SubscriptionImagineBlock() {
  return <div className="grid min-w-0 gap-3 lg:grid-cols-[.72fr_1.28fr] lg:items-stretch" data-id="element-2027" data-mp="m1qljixdcn9q">
      <aside className="relative overflow-hidden rounded-[1.75rem] bg-navy-950 p-4 text-white shadow-xl sm:p-5" data-id="element-2028" data-mp="m3ju53rjlhkd">
        <div className="pointer-events-none absolute -right-12 -top-12 h-36 w-36 rounded-full border-[22px] border-blue-400/10" aria-hidden="true" data-id="element-2029" data-mp="1eqe9jm9i5qqz" />
        <p className="relative text-[10px] font-bold uppercase tracking-[.2em] text-blue-300" data-id="element-2030" data-mp="100qakrosn46f">Imagine this</p>
        <h3 className="relative mt-2 text-xl font-bold leading-tight sm:text-[22px]" data-id="element-2031" data-mp="14z0653efk6sk">
          Hydration becomes a subscription — the way mobility became a tap.
        </h3>
        <div className="relative mt-4 rounded-2xl border border-blue-300/35 bg-blue-400/10 p-3" data-id="element-2032" data-mp="1xhxcjt3j14t0">
          <div className="flex items-start justify-between gap-2" data-id="element-2033" data-mp="27bt5r2mnw1l7">
            <div data-id="element-2034" data-mp="22e12xdkhav28">
              <p className="text-[9px] font-bold uppercase tracking-[.18em] text-blue-200" data-id="element-2035" data-mp="22dja6qx0yyz2">SIP membership</p>
              <p className="mt-1 text-lg font-bold leading-none text-white" data-id="element-2036" data-mp="1yb4rc6tcvz7s">Unlimited pours</p>
            </div>
            <span className="pd3-sip-tap flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-blue-400 text-navy-950" data-id="element-2037" data-mp="1tcbe8fhzea85">
              <SmartphoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-2038" data-mp="1og33rfeqb57b" />
            </span>
          </div>
          <div className="mt-3 flex flex-wrap items-end justify-between gap-x-2 gap-y-1 border-t border-white/15 pt-2.5" data-id="element-2039" data-mp="1jlgp93dcowj0">
            <p className="text-base font-bold text-white sm:text-sm" data-id="element-2040" data-mp="1amvc5nqne9pm">
              $22 <span className="text-[11px] font-semibold text-slate-300 sm:text-[10px]" data-id="element-2041" data-mp="1aksag6g4us52">/ month</span>
            </p>
            <p className="text-[11px] font-semibold text-blue-100 sm:text-[10px]" data-id="element-2042" data-mp="10ofm7o3cx6hp">Any JuLi endpoint, anywhere</p>
          </div>
        </div>
        <ul className="relative mt-3 space-y-1.5" data-id="element-2043" data-mp="3cazhv4rbamom">
          {membershipFeatures.map(feature => <li key={feature} className="flex items-center gap-2 text-xs font-semibold text-slate-200 sm:text-[11px]" data-id="element-2044" data-mp="3h9kih5ah78dl">
              <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-blue-400/25 text-blue-200" data-id="element-2045" data-mp="3maqbl481sxnn">
                <CheckIcon className="h-2.5 w-2.5" aria-hidden="true" data-id="element-2046" data-mp="2tl9q6qiuih0x" />
              </span>
              {feature}
            </li>)}
        </ul>
      </aside>

      <div className="min-w-0 rounded-[1.75rem] border border-blue-200 bg-blue-50/70 p-4 sm:p-5" data-id="element-2047" data-mp="2ykm9506lj3y8">
        <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-2048" data-mp="32kofvnr6unkd">
          <p className="text-[11px] font-bold uppercase tracking-[.16em] text-blue-700 sm:text-[10px] sm:tracking-[.18em]" data-id="element-2049" data-mp="37dhju9eu1rve">One member, one day on the network</p>
          <span className="rounded-full border border-blue-200 bg-white px-2.5 py-1 text-[10px] font-bold uppercase tracking-[.1em] text-blue-700 sm:text-[9px] sm:tracking-[.12em]" data-id="element-2050" data-mp="2ew57l8852asa">5 pours · 5 places · 1 subscription</span>
        </div>

        <div className="pd3-sip-track relative mt-3 sm:mt-4" data-id="element-2051" data-mp="1qu05b2ky1ehb">
          <span className="pd3-sip-pulse absolute top-[19px] hidden h-2 w-2 -translate-x-1/2 rounded-full bg-blue-600 shadow-[0_0_0_4px_rgba(37,99,235,.16)] sm:block" aria-hidden="true" data-id="element-2052" data-mp="25hbita0or8k2" />
          <ol className="deck-stagger relative grid grid-cols-1 gap-1.5 sm:grid-cols-5" aria-label="A single membership used across one day" data-id="element-2053" data-mp="2ei9kvmrkd600">
            {dayStops.map(({
            time,
            place,
            drink,
            Icon,
            tone
          }) => <li key={place} className="deck-stagger-item flex min-w-0 items-center gap-3 rounded-xl border border-blue-100 bg-white px-2.5 py-2 sm:flex-col sm:items-center sm:gap-0 sm:rounded-none sm:border-0 sm:bg-transparent sm:p-0 sm:text-center" data-id="element-2054" data-mp="2og5ziojpmj2v">
                <span className={`relative z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 sm:h-10 sm:w-10 sm:ring-4 sm:ring-blue-50 ${tone === 'home' ? 'border-navy-950 bg-navy-950 text-blue-200' : 'border-blue-300 bg-white text-blue-600'}`} data-id="element-2055" data-mp="p3v2rlb1whdh">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-2056" data-mp="2r1nenh43mjkk" />
                </span>
                <div className="min-w-0 sm:mt-2 sm:w-full" data-id="element-2057" data-mp="2vzoult68a2rt">
                  <p className="text-[10px] font-bold uppercase tracking-[.1em] text-blue-700 sm:text-[9px]" data-id="element-2058" data-mp="2vxvocezj1kkc">{time}</p>
                  <p className="mt-0.5 text-sm font-bold text-navy-950 sm:mt-1 sm:truncate sm:text-[11px]" data-id="element-2059" data-mp="2m1snrdkbptzi">{place}</p>
                  <p className="mt-0.5 text-[11px] font-semibold leading-tight text-slate-500 sm:text-[9px]" data-id="element-2060" data-mp="282j7yf0151w2">{drink}</p>
                </div>
              </li>)}
          </ol>
        </div>

        <div className="mt-3 grid gap-2 border-t border-blue-200 pt-3 sm:mt-4 sm:grid-cols-3" data-id="element-2061" data-mp="6a4tjpwp2fke">
          {networkEffects.map(([title, detail]) => <div key={title} className="rounded-xl border border-blue-100 bg-white px-3 py-2 shadow-sm" data-id="element-2062" data-mp="b8y69g45q2ji">
              <p className="text-[11px] font-bold leading-tight text-blue-700 sm:text-[10px]" data-id="element-2063" data-mp="9qhe3ap2hlx2">{title}</p>
              <p className="mt-1 text-[11px] leading-snug text-slate-500 sm:text-[10px]" data-id="element-2064" data-mp="4vk9cfytlypz">{detail}</p>
            </div>)}
        </div>
      </div>
    </div>;
}